<div *ngIf="restrictAccess$ | async">
    <p>You are currently unable to create a new user profile. Please get in touch with an account administrator for
        more details.</p>
</div>
<div class="section__buttons" *ngIf="!props.disabled">
    <sl-button [disabled]="restrictAccess$ | async" (click)="onClickCreate()" class="btn--secondary">Create Linked Profile <img
            class="lock-svg"
            alt="[lock]"
            *ngIf="restrictAccess$ | async"
            src="/ui-forms/v1/public/assets/images/lock-solid.svg"/></sl-button>
</div>
